<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">SEND TO OPERATOR</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div>
                        <h6 class="d-flex justify-content-left">ECN Status</h6>
               <div class="inventory-legend">
                          <span class="legend-color dark-green-legend" title="All ECN Sent"></span>
                          <!-- <span class="legend-color light-green-legend" title="Partial ECN Sent"></span> -->
                          <span class="legend-color dark-blue-legend" title="All Operator Sent"></span>
                          <!-- <span class="legend-color light-blue-legend" title="Partial Operator Sent"></span> -->
                          <span class="legend-color pink-orange" title="Inventory Offer Exists"></span>
                        </div>
                        </div>
            <!-- <h4 style="color:#1c91d2">{{cusipName}}</h4>
            <h5 style="color:rgb(69 69 69)">{{cusipDes}}</h5> -->
            <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
            <thead class="thead-light psticky">
                <tr>
                    <th scope="col">CUSIP/DESC</th>
                    <th scope="col" class="text-left">CUSTOMER <br>ACCOUNT | TYPE</th>
                    <th scope="col">BOUGHT</th>
                    <th scope="col">COST</th>
                    <!-- <th scope="col">CUSIP/DESC</th> -->
                    <!-- <th scope="col">COUPON</th> -->
                    <!-- <th scope="col">MATURITY DATE/<br>CALL DATE</th>
                    <th scope="col">MOODY'S/ <br>S&P RATING</th>
                    <th scope="col">INSURER</th>
                    <th scope="col">BOUGHT</th>
                    <th scope="col">COST</th>
                    <th scope="col">CLOSING PX</th> -->
                    <th scope="col">QTY</th>
                    <th scope="col">AVLB QTY</th>
                    <th 
                        scope="col" 
                        class="sort text-left"
                        >SELL QTY</th> 
                    <th 
                    scope="col" 
                    class="sort text-left"
                    >SPREAD</th>
                    <th scope="col">ACTION</th>

                </tr>
            </thead>
            <tbody>
                <tr v-for="(holding,index) in localHolding" :key="holding.id"  >
                    <td class="text-center">
                        <span class="cusip-highlight" :class="getRowColor(holding.highlightColor)">{{holding.cusipVal}}</span><br>
                        <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                    </td>
                    <td class="text-left">
                        <span class="">{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                        <span>{{holding.accountVal}}</span> | 
                        <span class="">{{holding.accountType}}</span> 
                    </td>
                    <td class="text-center">
                        <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span>
                    </td>
                     <td class="text-center">
                        <span class="">{{holding.cost | currency}}</span><br>
                    </td>
                    <!-- <td class="text-center">
                        <span class="cusips">{{holding.cusipVal}}</span><br>
                        <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                    </td> -->
                    <!-- <td class="text-center"><span>{{holding.coupon |  percent(3) }}</span></td> -->
                    <!-- <td class="text-center">
                        <span class="maturity">{{holding.maturityDate ? moment(holding.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                    {{holding.callDate ? moment(holding.callDate).format("MM/DD/YYYY") : "N/A"}}
                    </td>
                    <td class="text-center"><span class="text-primary">{{holding.ratingMoody ? holding.ratingMoody : "N/A"}}</span>
                        <span class="insurer text-success">{{holding.ratingSP ? holding.ratingSP : "N/A"}}</span>
                    </td>
                    <td class="text-center"><span class="insurer">{{holding.bondInsurer ? holding.bondInsurer : "N/A"}}</span></td>
                    <td class="text-center">
                        <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span>
                    </td>
                    <td class="text-center">
                        <span class="text-success">{{holding.cost}}</span><br>
                    </td>
                    <td class="text-center">
                        <span class="text-danger">{{holding.closingPx}}</span><br>
                    </td> -->
                    <td class="text-center">
                        <span>{{holding.quantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <span>{{holding.remainQuantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <span class="sell-qty"><input type="number"  class="form-control" placeholder="Qty"  v-model.number="holding.sellQuantity"></span><br>
                    </td> 
                    <td class="text-center">
                        <span class="sell-qty"><input type="number"  @change="setSpread(holding.spread,holding.customerId)" class="form-control" placeholder="Spread"  v-model.number="holding.spread"></span><br>
                    </td> 
                    <td @click="deleteHolding(index)">
                        <span class="cursor-pointer">
                          <i class="far fa-trash-alt"></i>
                        </span>
                    </td>
                </tr>    
                
            </tbody>
            </table> 
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div>
            <span v-if="isUploadInProgress()" class="alert alert-danger" role="alert">
                Holding upload is currently in progress. Please try again once it’s complete.
            </span>
            </div>
            <br>
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                <button :disabled="isUploadInProgress() || holding.length == 0" @click="sendToOperator()" type="button" class="btn btn-success" >SEND TO OPERATOR</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import config from "@/config";
import authService from "@/authService";
export default {
    name: 'createbidwanted',
    props: ['holding'],
    components :{
        
    },
    data() {
        return {
            loading : false,
            localHolding : [],
            cusipName : this.holding ? this.holding[0].cusipVal : "",
            cusipDes : this.holding ? this.holding[0].cusipDescription : ""

        }

    },
    methods:{
        setSpread(spread,customerId){
            if(customerId){
                this.localHolding.forEach((element) => {
                    if(element.customerId == customerId){
                        element.spread = spread
                    }
                });
            }
        },
        deleteHolding(holdingIndex){
            var message = `Are you sure you want to delete?`;
            this.$confirm(message,"","question",{confirmButtonText:"DELETE",cancelButtonText : "NO"}).then(() => {
                this.localHolding.splice(holdingIndex,1)
            })
        },
        checkValid(){
            let isValid = true;
            let cusipType = this.localHolding[0].offeringTypeId === 1 ? "Munis" : "Corporates";
            this.localHolding.forEach((holding) => {
                if(!holding.sellQuantity){
                    isValid = false;
                    this.$alert("Fill all holdings sell quantity","","error");
                    return;
                 }
                if(holding.remainQuantity < holding.sellQuantity){
                    isValid = false;
                    this.$alert("Quantity entered is greater than available quantity.","","error");
                    return;
                 }
                if(cusipType == 'Munis' &&  holding.sellQuantity % 5 != 0 ){
                    isValid = false;
                    this.$alert("Holding quantity is not multiples of 5","","error");
                    return ;
                }
            });
            return isValid
        },
        sendToOperator(){
            if(this.checkValid()){
                var message = `Are you sure you want to send this holding to the operator?`;
                this.$confirm(message,"","question",{confirmButtonText:"SEND TO OPERATOR",cancelButtonText : "NO"}).then(() => {
                    this.loading = true;
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    let bidWantedData = {
                            "traderCognitoSub": authService.getUser().cognitoSub,
                            "bidWanted" : []
                        }
                    // Group by cusipId AND accountId so each entry holds bid wanteds of the same account.
                    const groupMap = {};
                    this.localHolding.forEach((holding) => {
                        const groupKey = holding.cusipId + "-" + holding.accountMappingId;
                        if(!groupMap[groupKey]){
                            groupMap[groupKey] = {"cusipId": holding.cusipId,"bidWantedHoldingDtos":[]};
                            bidWantedData.bidWanted.push(groupMap[groupKey]);
                        }
                        groupMap[groupKey].bidWantedHoldingDtos.push({accountId : holding.accountMappingId, inventoryId : holding.id,quantity : holding.sellQuantity,spread : holding.spread})
                    });
                    console.log(bidWantedData)
                    this.$http
                    .post(config.baseUrlBidSide + "/bidwanted",bidWantedData,auth)
                    .then((response) => {
                        this.loading = false;
                        const res = response.data || {};
                        const colorMap = res.bidwantedColorMapList || {};
                        // Keep only holdings present in bidwantedColorMapList (keys are inventoryId); remove the rest.
                        this.localHolding = this.localHolding.filter(holding =>
                            colorMap[holding.inventoryId] !== undefined || colorMap[holding.id] !== undefined
                        );
                        // Update row colors returned from the server (keys are inventoryId)
                        this.localHolding.forEach(holding => {
                            const color = colorMap[holding.inventoryId] || colorMap[holding.id];
                            if(color){
                                this.$set(holding, 'highlightColor', color);
                            }
                        });
                        // Re-sort so highlighted (colored) records stay on top
                        const isHighlighted = h => h.highlightColor && h.highlightColor !== "NO_COLOR" ? 1 : 0;
                        this.localHolding.sort((a, b) => isHighlighted(b) - isHighlighted(a));

                        if(res.failedSentBidwantedCount > 0){
                            // Some bid wanteds could not be sent to operator — keep the popup open so the user can review the highlighted rows.
                            this.$alert(res.failedSentBidwantedCount + " bid wanted(s) could not be sent to operator. Please review the highlighted holdings.","","warning");
                        }else{
                            this.$alert("Your holding has been successfully sent to operator","","success");
                            this.$emit('close');
                        }
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                })
            }
        }
    },
    mounted(){
        //Resstructured Holdings.

        this.localHolding = this.holding.flatMap(item =>
            item.invDetails.map(detail => ({
                ...item,
                ...detail,
                sellQuantity : item.invDetails.length > 1 ?  detail.remainQuantity : item.sellQuantity,
               // invDetails: undefined // optional: remove the nested invDetails from the final output
            }))
            );

        // Colored (highlighted) records always on top; sort is stable so the rest keep their order.
        const isHighlighted = h => h.highlightColor && h.highlightColor !== "NO_COLOR" ? 1 : 0;
        this.localHolding.sort((a, b) => isHighlighted(b) - isHighlighted(a));

            // console.log(output);
        console.log(this.holding)
        console.log(this.localHolding)


    }
};
</script>
<style scoped>
.table i {
 color: #E96875 !important; 
}
</style>